import './index.scss';

import { Component } from 'react';

import { BraxImageSource } from '../../types';
import { BraxIcon } from '../BraxIcon';

export type BraxGalleryProps = {
    images: BraxImageSource[]
};

type BraxGalleryState = {
    currentIndex: number
};

export class BraxGallery extends Component<BraxGalleryProps, BraxGalleryState> {

    state = {
        currentIndex: 0
    };

    move(direction: 'left' | 'right') {
        const target = this.state.currentIndex + (direction === 'left' ? -1 : +1);

        this.setState({
            currentIndex: Math.min(Math.max(target, 0), this.props.images.length - 1)
        });
    }

    render() {
        let classes = 'brax-gallery';

        if (this.state.currentIndex === 0)
            classes += ' first'
        else if (this.state.currentIndex === this.props.images.length - 1)
            classes += ' last'

        return (
            <div className={classes}>
                <div>
                    <div style={{ '--current-index': `${this.state.currentIndex}` } as any}>
                        { this.props.images.map(image => (
                            <div key={image.src}>
                                <img {...image} />
                            </div>
                        )) }
                    </div>
                </div>

                <BraxIcon icon="arrow" rotation={90} onClick={() => this.move('left')} />

                <BraxIcon icon="arrow" rotation={-90} onClick={() => this.move('right')} />
            </div>
        );
    }

}
